class FlashesExtension {
    initialize(naja)
    {
        window.addEventListener('DOMContentLoaded', this.closeAlerts.bind(this));
        naja.addEventListener('complete', this.closeAlerts.bind(this));
    }

    closeAlerts()
    {
        const alerts = document.querySelectorAll('.alert');

        // If alert is empty we can just skip it
        alerts.forEach((alert) => {
            const closeButton = alert.querySelector('.btn-close');
            const tempAlert = alert.cloneNode(true);
            const tempCloseButton = tempAlert.querySelector('.btn-close');
            if (tempCloseButton) {
                tempCloseButton.remove();
            }

            if (tempAlert.textContent.trim() === '') {
                alert.remove();

            } else {
                if (closeButton) {
                    setTimeout(() => {
                        closeButton.click();
                    }, 6000); // 6 seconds
                }
            }
        });
    }
}

export default FlashesExtension;
